var cilVideo = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M461,132,360,171.277V72H16V440H360V332.723L461,372h35V132Zm3,206.833-136-52.89V408H48V104H328V218.057l136-52.89Z' class='ci-primary'/>"];

export { cilVideo };

